<template>
  <div>
    <template v-if="fdata">
      <div class="row table-head p-2 no-margin justify-content-center"
        style="font-size: 18px; background-color: #004242;"><strong>General</strong></div>
      <div class="clearfix mb-2 pb-2 dashed-border">

        <div class="row table-row hover-bg no-margin">
          <div class="col-md-6 border-right py-2"><strong>Contract Reference:</strong></div>
          <div class="col-md-6 py-2">{{ fdata.contract_reference }}</div>
        </div>

        <div class="row table-row hover-bg no-margin">
          <div class="col-md-6 border-right py-2"><strong>Employee:</strong></div>
          <div class="col-md-6 py-2">{{ fdata.employee_name }}</div>
        </div>

        <div class="row table-row hover-bg no-margin">
          <div class="col-md-6 border-right py-2"><strong>Department:</strong></div>
          <div class="col-md-6 py-2">{{ fdata.department }}</div>
        </div>

        <div class="row table-row hover-bg no-margin">
          <div class="col-md-6 border-right py-2"><strong>Employee Type:</strong></div>
          <div class="col-md-6 py-2">{{ fdata.employee_type ? fdata.employee_type : fdata.employee_employee_type }}
          </div>
        </div>

        <div class="row table-row hover-bg no-margin">
          <div class="col-md-6 border-right py-2"><strong>Job Position:</strong></div>
          <div class="col-md-6 py-2">{{ fdata.jobposition }}</div>
        </div>

        <div class="row table-row hover-bg no-margin">
          <div class="col-md-6 border-right py-2"><strong>Work Location:</strong></div>
          <div class="col-md-6 py-2">{{ fdata.branch }}</div>
        </div>

        <div class="row table-row hover-bg no-margin">
          <div class="col-md-6 border-right py-2"><strong>Start Date:</strong><span
              class="custom-date-indicator">(YYYY-MM-DD)</span></div>
          <div class="col-md-6 py-2">{{ formatMe(fdata.contract_start) }}</div>
        </div>

        <div class="row table-row hover-bg no-margin">
          <div class="col-md-6 border-right py-2"><strong>End Date:</strong><span
              class="custom-date-indicator">(YYYY-MM-DD)</span></div>
          <div class="col-md-6 py-2">{{ formatMe(fdata.contract_end) }}</div>
        </div>

        <!--Contract effective date Start-->
        <div class="row table-row hover-bg no-margin">
          <div class="col-md-6 border-right py-2"><strong>Effective Date:</strong><span
              class="custom-date-indicator">(YYYY-MM-DD)</span></div>
          <div class="col-md-6 py-2">{{ fdata.effective_date ? formatMe(fdata.effective_date) : '' }}</div>
        </div>
        <!--Contract effective date End-->

        <div class="row table-row hover-bg no-margin">
          <div class="col-md-6 border-right py-2"><strong>Reporting Manager:</strong></div>
          <div class="col-md-6 py-2"></div>
        </div>

        <!--<div class="row" v-if="fdata.has_probation==1">
                <div class="col-md-12">Probation Period</div>
            </div>-->

        <!--<div class="row" v-if="fdata.has_probation==1 && fdata.probation_start">
                <div class="col-md-6"><span class="info-head">Probation Period Start:</span></div>
                <div class="col-md-6">{{fdata.probation_start}}</div>
            </div>-->

        <!--<div class="row" v-if="fdata.has_probation==1 && fdata.probation_end">
                <div class="col-md-6"><span class="info-head">Probation Period End:</span></div>
                <div class="col-md-6">{{fdata.probation_end}}</div>
            </div>-->
      </div>

      <template v-if="fdata.has_probation == 1">
        <div class="row table-head p-2 no-margin justify-content-center mt-5"
          style="font-size: 18px; background-color: #004242;"><strong>Probation</strong></div>
        <div class="row table-row hover-bg no-margin">
          <div class="col-md-6 border-right py-2"><span class="info-head">Probation Gross Salary:</span></div>
          <div class="col-md-6 py-2 text-right">{{ moneyFormat(probation_salary['probation_gross_salary']) }}</div>
        </div>
        <template v-for="(pb_component, index) in salary_settings.probation_data">
          <template v-if="pb_component.field_key != 'probation_gross_salary'">
            <div class="row table-row hover-bg no-margin">
              <div class="col-md-6 border-right py-2"><span class="info-head">{{ pb_component.field_title }}</span>
              </div>
              <div class="col-md-6 py-2 text-right">{{ moneyFormat(probation_salary[pb_component.field_key]) }}</div>
            </div>
          </template>
        </template>


        <template
          v-if="salary_settings.customized_payroll_report && salary_settings.customized_payroll_report[0]['status'] == 1">
          <template v-for="(customized_payroll_component, index) in salary_settings.customized_payroll_report">
            <template v-if="customized_payroll_component.child_components">
              <div class="row table-head p-2 no-margin justify-content-center mt-5"
                style="font-size: 18px; background-color: #004242;"><strong>Customized payroll report probation
                  heads</strong></div>
              <template v-for="customized_payroll_report_child in customized_payroll_component.child_components">
                <div class="row table-row hover-bg no-margin"
                  v-if="customized_payroll_report_child.field_access_key.indexOf('probation_') === 0 && customized_payroll_report_child.status == 1">
                  <div class="col-md-6 border-right py-2"><span class="info-head">{{
                      customized_payroll_report_child.field_title }}</span></div>
                  <div class="col-md-6 py-2 text-right">{{ moneyFormat(customized_payroll_report_child.field_value) }}
                  </div>
                </div>
              </template>
              <div class="row table-row hover-bg no-margin">
                <div class="col-md-6 border-right py-2"><strong>Probation Gross Salary (Custom Report)</strong></div>
                <div class="col-md-6 py-2 text-right">{{ moneyFormat(customized_payroll_component.customized_prb_total)
                  }}
                </div>
              </div>
            </template>
          </template>
        </template>

      </template>

      <div class="row table-head p-2 no-margin justify-content-center mt-5"
        style="font-size: 18px; background-color: #004242;"><strong>Salary Information</strong></div>
      <div class="clearfix mb-2 pb-2 dashed-border">
        <template v-for="(fixed_component, index) in salary_settings.fixed">
          <template
            v-if="fixed_component.field_key == 'basic_salary' || fixed_component.field_key == 'house_rent' || fixed_component.field_key == 'conveyance_allowance' || fixed_component.field_key == 'medical_allowance' || fixed_component.field_key.indexOf('custom_gross_salary') === 0 && fixed_component.field_key != 'medical_reimbursement' && fixed_component.field_key != 'tax_calculation_type'">
            <!-- gross salary update -->


            <div class="row table-row hover-bg no-margin">
              <div class="col-md-6 border-right py-2"><strong>{{ fixed_component.field_title }}</strong></div>
              <div class="col-md-6 py-2 text-right">{{ moneyFormat(component_values[fixed_component.field_name]) }}
              </div>
            </div>

          </template>
        </template>
        <div class="row table-row hover-bg no-margin">
          <div class="col-md-6 border-right py-2"><strong>Gross Salary:</strong></div>
          <div class="col-md-6 py-2 text-right">{{ moneyFormat(fdata.gross) }}</div>
        </div>
      </div>


      <div class="row table-head p-2 no-margin justify-content-center mt-5"
        style="font-size: 18px; background-color: #004242;"><strong>Tax Policy Information</strong></div>
      <div class="row table-row hover-bg no-margin mb-5">
        <div class="col-md-6 border-right py-2">
          <strong>Tax Policy</strong>
        </div>
        <div class="col-md-6 py-2" v-if="fdata.tax_policy == 1">
          Borne by employer
        </div>
        <div class="col-md-6 py-2" v-else>
          Deducted from employee
        </div>
      </div>

      <template
        v-if="salary_settings.customized_payroll_report && salary_settings.customized_payroll_report[0]['status'] == 1">
        <template v-for="(customized_payroll_component, index) in salary_settings.customized_payroll_report">
          <template v-if="customized_payroll_component.child_components">
            <div class="row table-head p-2 no-margin justify-content-center mt-5"
              style="font-size: 18px; background-color: #004242;"><strong>Customized payroll report heads</strong></div>
            <template v-for="customized_payroll_report_child in customized_payroll_component.child_components">
              <div class="row table-row hover-bg no-margin"
                v-if="customized_payroll_report_child.field_access_key.indexOf('probation_') !== 0 && customized_payroll_report_child.status == 1">
                <div class="col-md-6 border-right py-2"><span class="info-head">{{
                    customized_payroll_report_child.field_title }}</span></div>
                <div class="col-md-6 py-2 text-right">{{ moneyFormat(customized_payroll_report_child.field_value) }}
                </div>
              </div>
            </template>
            <div class="row table-row hover-bg no-margin">
              <div class="col-md-6 border-right py-2"><strong>Gross Salary (Custom Report)</strong></div>
              <div class="col-md-6 py-2 text-right">{{ moneyFormat(customized_payroll_component.customized_total) }}
              </div>
            </div>
          </template>
        </template>
      </template>

      <template v-for="(fixed_component, index) in salary_settings.fixed">

        <template
          v-if="fixed_component.field_key != 'basic_salary' && fixed_component.field_key != 'house_rent' && fixed_component.field_key != 'conveyance_allowance' && fixed_component.field_key != 'medical_allowance' && fixed_component.field_key != 'rent_free_accommodation' && fixed_component.field_key != 'conveyance_personal_private' && fixed_component.field_key.indexOf('custom_gross_salary_') < 0">
          <!-- gross salary update -->

          <template v-if="fixed_component.date_range == 1">
            <div class="row table-row hover-bg no-margin">
              <div class="col-md-6 border-right py-2"><strong><template
                    v-if="fixed_component.field_title == 'Rent-free accommodation'">Rent Free
                    Accommodation</template><template v-else>{{ fixed_component.field_title }}</template></strong>
              </div>
              <div class="col-md-6 py-2"><template
                  v-if="component_values[fixed_component.field_key + '_start_date'] != ''">Availed</template><template
                  v-else>Not Availed</template></div>
            </div>
            <div class="row table-row hover-bg no-margin" v-if="component_values[fixed_component.field_name] == 1">
              <div class="col-md-6 border-right py-2"><strong>Start Date:</strong><span
                  class="custom-date-indicator">(YYYY-MM-DD)</span></div>
              <div class="col-md-6 py-2">{{ formatMe(component_values[fixed_component.field_key + '_start_date']) }}
              </div>
            </div>
            <div class="row table-row hover-bg no-margin"
              v-if="component_values[fixed_component.field_name] == 1 && component_values[fixed_component.field_key + '_end_date']">
              <div class="col-md-6 border-right py-2"><strong>End Date:</strong><span
                  class="custom-date-indicator">(YYYY/MM/DD)</span></div>
              <div class="col-md-6 py-2">{{ formatMe(component_values[fixed_component.field_key + '_end_date']) }}</div>
            </div>

            <!--<div class="row table-row hover-bg no-margin" v-if="fixed_component.field_name == 'rent_free_accommodation' && component_values[fixed_component.field_name] == 1 && fdata.rental_amount">
                <div class="col-md-6 border-right py-2"><strong>Monthly Rental Amount:</strong></div>
                <div class="col-md-6 py-2 text-right text-right">{{moneyFormat(fdata.rental_amount)}}</div>
              </div>-->
            <template
              v-if="fixed_component.field_name == 'rent_free_accommodation' && component_values[fixed_component.field_name] == 1 && fdata.rental_amount">
              <!-- non-cash update satrt -->
              <div class="row table-row hover-bg no-margin">
                <div class="col-md-6 border-right py-2"><strong>Monthly Rental Amount:</strong></div>
                <div class="col-md-6 py-2 text-right text-right">{{ moneyFormat(fdata.rental_amount) }}</div>
              </div>
              <div class="row table-row hover-bg no-margin">
                <div class="col-md-6 border-right py-2"><strong>Rent Paid by Employee:</strong></div>
                <div class="col-md-6 py-2 text-right text-right">{{ moneyFormat(fdata.rent_paid_by_employee) }}</div>
              </div>
              <div class="row table-row hover-bg no-margin">
                <div class="col-md-6 border-right py-2"><strong>Rent Paid by Employee:</strong></div>
                <div class="col-md-6 py-2 text-right text-right">{{ moneyFormat(fdata.rent_paid_by_employee) }}</div>
              </div>
              <div class="row table-row hover-bg no-margin">
                <div class="col-md-6 border-right py-2"><strong>Perquisite Amount:</strong></div>
                <div class="col-md-6 py-2 text-right text-right">{{ moneyFormat(fdata.rental_amount -
                  fdata.rent_paid_by_employee) }}</div>
              </div>

            </template><!-- non-cash update end -->
          </template>
          <template v-else>

            <div class="row table-row hover-bg no-margin" v-if="fixed_component.section_only != 1">
              <div class="col-md-6 border-right py-2"><strong>{{ fixed_component.field_title }}</strong></div>
              <div class="col-md-6 py-2"><strong>{{ component_values[fixed_component.field_name] }}</strong></div>
            </div>
            <div class="row table-head p-2 no-margin justify-content-center mt-5"
              style="font-size: 18px; background-color: #004242;"
              v-else-if="fixed_component.field_key != 'other_non_taxable_monthly_allowance'"><strong><span
                  v-if="fixed_component.field_key == 'other_monthly_allowance'">Other Monthly Allowances</span><span
                  v-else>{{ fixed_component.field_title }}</span></strong></div>

            <template v-if="fixed_component.child_components">
              <template v-for="fixed_child in fixed_component.child_components">

                <div class="row table-row hover-bg no-margin" v-if="fixed_child.is_checked == 1">
                  <div class="col-md-6 border-right py-2"><strong>{{ fixed_child.field_title }}</strong></div>
                  <div class="col-md-6 py-2 text-right">{{ moneyFormat(component_values[fixed_child.field_key]) }}</div>
                </div>

              </template>
            </template>
          </template>
        </template>
      </template>

      <template v-if="salary_settings.contracted_variable_benefits">
        <template v-for="(contracted_component, index) in salary_settings.contracted_variable_benefits">

          <div class="row table-row hover-bg no-margin" v-if="contracted_component.section_only != 1">
            <div class="col-md-6 border-right py-2"><strong>{{ contracted_component.field_title }}</strong></div>
            <div class="col-md-6 py-2"><strong>{{ component_values[contracted_component.field_name] }}</strong></div>
          </div>
          <div v-else class="row table-head p-2 no-margin justify-content-center mt-5"
            style="font-size: 18px; background-color: #004242;">
            <strong><span>{{ contracted_component.field_title }}</span></strong>
          </div>

          <template v-if="contracted_component.child_components">
            <template v-for="contracted_child in contracted_component.child_components">

              <div class="row table-row hover-bg no-margin" v-if="contracted_child.is_checked == 1">
                <div class="col-md-6 border-right py-2"><strong>{{ contracted_child.field_title }}</strong></div>
                <div class="col-md-6 py-2 text-right">{{ moneyFormat(contracted_child.field_value) }}</div>
              </div>

            </template>
          </template>
        </template>
      </template>



      <div class="row table-head p-2 no-margin justify-content-center mt-5"
        style="font-size: 18px; background-color: #004242;"><strong>Non Cash Benefits</strong></div>
      <template v-for="(fixed_component, index) in salary_settings.fixed">

        <template
          v-if="fixed_component.field_key == 'rent_free_accommodation' || fixed_component.field_key == 'conveyance_personal_private'">

          <template v-if="fixed_component.date_range == 1">
            <div class="row table-row hover-bg no-margin">
              <div class="col-md-6 border-right py-2"><strong><template
                    v-if="fixed_component.field_title == 'Rent-free accommodation'">Rent Free
                    Accommodation</template><template v-else>{{ fixed_component.field_title }}</template></strong>
              </div>
              <div class="col-md-6 py-2">
                <template v-if="fixed_component.field_key != 'conveyance_personal_private'">
                  <template
                    v-if="component_values[fixed_component.field_key] == 1 || component_values[fixed_component.field_key + '_start_date'] != ''">Availed</template>
                  <template v-else>Not Availed</template>
                </template>
                <template v-else>
                  <!-- New slabs for conveyance personal/private related updates: Sohel -->
                  <template
                    v-if="fdata.conveyance_personal_private_cars_upto_1500_cc || fdata.conveyance_personal_private_cars_1501_to_2000_cc || fdata.conveyance_personal_private_cars_2001_to_2500_cc || fdata.conveyance_personal_private_cars_above_2500_cc">Availed</template>
                  <template v-else>Not Availed</template>
                  <!-- New slabs for conveyance personal/private related updates: Sohel -->
                </template>
              </div>
            </div>
            <template v-if="fixed_component.field_key != 'conveyance_personal_private'">
              <div class="row table-row hover-bg no-margin"
                v-if="fixed_component.field_key != 'rent_free_accommodation' && component_values[fixed_component.field_name] == 1">
                <div class="col-md-6 border-right py-2"><strong><span
                      v-if="fixed_component.field_key == 'conveyance_personal_private'">CPU</span><span
                      v-else>RFA</span> Start Date:</strong><span class="custom-date-indicator">(YYYY-MM-DD)</span>
                </div>
                <div class="col-md-6 py-2">{{ formatMe(component_values[fixed_component.field_key + '_start_date']) }}
                </div>
              </div>
              <div class="row table-row hover-bg no-margin"
                v-if="component_values[fixed_component.field_name] == 1 && component_values[fixed_component.field_key + '_end_date']">
                <div class="col-md-6 border-right py-2"><strong><span
                      v-if="fixed_component.field_key == 'conveyance_personal_private'">CPU</span><span
                      v-else>RFA</span> End Date:</strong><span class="custom-date-indicator">(YYYY/MM/DD)</span></div>
                <div class="col-md-6 py-2">{{ formatMe(component_values[fixed_component.field_key + '_end_date']) }}
                </div>
              </div>
            </template>

            <template v-if="fixed_component.field_key == 'conveyance_personal_private'">
              <!-- New slabs for conveyance personal/private related updates: Sohel -->
              <div class="row table-row hover-bg no-margin" v-if="component_values[fixed_component.field_name] == 1">
                <div class="col-md-6 border-right py-2"><strong>Number of cars up to 1500cc:</strong></div>
                <div class="col-md-6 py-2">{{ fdata.conveyance_personal_private_cars_upto_1500_cc }}</div>
              </div>

              <div class="row table-row hover-bg no-margin" v-if="component_values[fixed_component.field_name] == 1">
                <div class="col-md-6 border-right py-2"><strong>Number of cars 1501cc to 2000cc:</strong></div>
                <div class="col-md-6 py-2">{{ fdata.conveyance_personal_private_cars_1501_to_2000_cc }}</div>
              </div>

              <div class="row table-row hover-bg no-margin" v-if="component_values[fixed_component.field_name] == 1">
                <div class="col-md-6 border-right py-2"><strong>Number of cars 2001cc to 2500cc:</strong></div>
                <div class="col-md-6 py-2">{{ fdata.conveyance_personal_private_cars_2001_to_2500_cc }}</div>
              </div>
              <!-- New slabs for conveyance personal/private related updates: Sohel -->
              <div class="row table-row hover-bg no-margin" v-if="component_values[fixed_component.field_name] == 1">
                <div class="col-md-6 border-right py-2"><strong>Number of cars above 2500cc:</strong></div>
                <div class="col-md-6 py-2">{{ fdata.conveyance_personal_private_cars_above_2500_cc }}</div>
              </div>
            </template>

            <!--<div class="row table-row hover-bg no-margin" v-if="fixed_component.field_name == 'rent_free_accommodation' && component_values[fixed_component.field_name] == 1 && fdata.rental_amount">
                <div class="col-md-6 border-right py-2"><strong>Monthly Rental Amount:</strong></div>
                <div class="col-md-6 py-2 text-right text-right">{{moneyFormat(fdata.rental_amount)}}</div>
              </div>-->
            <template
              v-if="fixed_component.field_name == 'rent_free_accommodation' && component_values[fixed_component.field_name] == 1 && fdata.rental_amount">
              <!-- non-cash update satrt -->
              <div class="row table-row hover-bg no-margin">
                <div class="col-md-6 border-right py-2"><strong>Monthly Rental Amount:</strong></div>
                <div class="col-md-6 py-2 text-right text-right">{{ moneyFormat(fdata.rental_amount) }}</div>
              </div>

              <div class="row table-row hover-bg no-margin">
                <div class="col-md-6 border-right py-2"><strong>Rent Paid by Employee:</strong></div>
                <div class="col-md-6 py-2 text-right text-right">{{ moneyFormat(fdata.rent_paid_by_employee) }}</div>
              </div>
              <div class="row table-row hover-bg no-margin">
                <div class="col-md-6 border-right py-2"><strong>Perquisite Amount:</strong></div>
                <div class="col-md-6 py-2 text-right text-right">{{ moneyFormat(fdata.rental_amount -
                  fdata.rent_paid_by_employee) }}</div>
              </div>
            </template> <!-- non-cash update end -->
          </template>
        </template>
      </template>







      <template v-for="(fixed_deduction, index) in salary_settings.fixed_deduction">
        <template v-if="fixed_deduction.date_range == 1">

          <div class="row table-row hover-bg no-margin">
            <div class="col-md-6 border-right py-2"><strong>{{ fixed_deduction.field_title }}</strong></div>
            <div class="col-md-6 py-2"></div>
          </div>

          <div class="row table-row hover-bg no-margin" v-if="component_values[fixed_deduction.field_name] == 1">
            <div class="col-md-6 border-right py-2"><strong>Start Date</strong><span
                class="custom-date-indicator">(YYYY/MM/DD)</span></div>
            <div class="col-md-6 py-2">{{ formatMe(component_values[fixed_deduction.field_key + '_start_date']) }}</div>
          </div>

          <div class="row table-row hover-bg no-margin" v-if="component_values[fixed_deduction.field_name] == 1">
            <div class="col-md-6 border-right py-2"><strong>End Date</strong><span
                class="custom-date-indicator">(YYYY/MM/DD)</span></div>
            <div class="col-md-6 py-2">{{ formatMe(component_values[fixed_deduction.field_key + '_end_date']) }}</div>
          </div>

        </template>
        <template v-else>

          <div class="row table-row hover-bg no-margin" v-if="fixed_deduction.section_only != 1">
            <div class="col-md-6 border-right py-2"><strong>{{ fixed_deduction.field_title }}</strong></div>
            <div class="col-md-6 py-2 text-right">
              <strong>{{ moneyFormat(component_values[fixed_deduction.field_name]) }}</strong>
            </div>
          </div>
          <div class="row table-head p-2 no-margin justify-content-center mt-5"
            style="font-size: 18px; background-color: #004242;" v-else><strong>Deductions</strong></div>

          <div class="row table-row hover-bg no-margin">
            <div class="col-md-6 border-right py-2"><strong>Income Tax</strong></div>
            <div class="col-md-6 py-2 text-left">As per law</div>
          </div>

          <template v-if="fixed_deduction.child_components">
            <template v-for="fixed_deduction_child in fixed_deduction.child_components">

              <div class="row table-row hover-bg no-margin" v-if="fixed_deduction_child.is_checked == 1">
                <div class="col-md-6 border-right py-2"><strong>{{ fixed_deduction_child.field_title }}</strong></div>
                <div class="col-md-6 py-2 text-right">{{ moneyFormat(component_values[fixed_deduction_child.field_key])
                  }}
                </div>
              </div>

            </template>
          </template>
        </template>
      </template>
      <div class="row table-head p-2 no-margin justify-content-center mt-5"
        style="font-size: 18px; background-color: #004242;"><strong>Provident Fund</strong></div>

      <div class="row table-row hover-bg no-margin">
        <div class="col-md-6 border-right py-2"><strong>Enrolled</strong></div>
        <div class="col-md-6 py-2" v-if="fdata.pf_start">Yes</div>
        <div class="col-md-6 py-2" v-else>No</div>
      </div>
      <div class="row table-row hover-bg no-margin" v-if="fdata.pf_start">
        <div class="col-md-6 border-right py-2"><strong>Start Date</strong><span
            class="custom-date-indicator">(YYYY-MM-DD)</span></div>
        <div class="col-md-6 py-2">{{ formatMe(fdata.pf_start) }}</div>
      </div>
      <div class="row table-row hover-bg no-margin">
        <div class="col-md-6 border-right py-2" v-if="fdata.pf_end"><strong>End Date</strong><span
            class="custom-date-indicator">(YYYY-MM-DD)</span></div>
        <div class="col-md-6 py-2" v-if="fdata.pf_end">{{ formatMe(fdata.pf_end) }}</div>
      </div>

      <div class="row table-head p-2 no-margin justify-content-center mt-5"
        style="font-size: 18px; background-color: #004242;"><strong>Leave Information</strong></div>
      <div class="row table-row hover-bg no-margin mb-5">
        <div class="col-md-6 border-right py-2">
          <strong>Leave Policy</strong>
        </div>
        <div class="col-md-6 py-2">
          {{ leave_policy == '' ? roster_leave_policy : leave_policy }} <!-- asfaq -->
        </div>
      </div>

      <div class="row table-head p-2 no-margin justify-content-center mt-5"
        style="font-size: 18px; background-color: #004242;"><strong>Cost Center Information</strong></div>
      <!-- Sohel: New mappings update -->
      <template v-if="cost_center_info.length != 0">
        <div class="row table-row hover-bg no-margin mb-2" v-for="c_c_list in cost_center_info"
          :key="c_c_list.cost_center_id">
          <div class="col-md-6 border-right py-2">
            <strong>Name</strong>
          </div>
          <div class="col-md-6 py-2">
            {{ c_c_list.cost_center_name }}
          </div>
          <div class="col-md-6 border-right py-2">
            <strong>Code</strong>
          </div>
          <div class="col-md-6 py-2">
            {{ c_c_list.code }}
          </div>
          <div class="col-md-6 border-right py-2">
            <strong>Cost Center Percentage</strong>
          </div>
          <div class="col-md-6 py-2">
            {{ c_c_list.cost_center_percentage }}
          </div>
        </div>
      </template>
      <!-- alpha fix- chnaged the N?A style and added style  -->
      <template v-else>
        <div class="row table-row hover-bg no-margin mb-5">
          <div class="col-md-12 py-2 text-center pl-0" style="padding-left: 0 !important;">
            N/A
          </div>
        </div>
      </template>
      <!-- Sohel: New mappings update -->

      <!-- start custom field changes -->
      <template v-if="salary_settings.contract_custom_fields && salary_settings.contract_custom_fields.length > 0">
        <div class="mb-5">
          <div class="row table-head p-2 no-margin justify-content-center mt-5"
            style="font-size: 18px; background-color: #004242;"><strong>Custom Fields</strong></div>
          <template v-for="(contract_custom_field) in salary_settings.contract_custom_fields">
            <div class="row table-row hover-bg no-margin">
              <div class="col-md-6 border-right py-2">
                <strong>{{ contract_custom_field.field_title }}</strong>
              </div>
              <div class="col-md-6 py-2">
                {{ contract_custom_field.field_value }}
              </div>
            </div>
          </template>
        </div>
      </template>
      <!-- end custom field changes -->

      <div class="row justify-content-center"
        v-if="$acl['contract/update'] == 2 && fdata.status == 3 && fdata.need_approval == 1">
        <b-button pill size="sm" variant="success" @click="contractApproval(fdata.id, 1, $event)"><b-icon
            icon="check-circle" class="m-1"></b-icon>Approve</b-button>
        <b-button pill size="sm" variant="danger" class="ml-2" @click="contractApproval(fdata.id, 0, $event)"><b-icon
            icon="x-circle" class="m-1"></b-icon>Disapprove</b-button>
      </div>

    </template>
    <template v-else>
      <p>Unable to load contract data!!!</p>
    </template>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  mounted() {
  },
  props: ['contract_id'],
  data() {

    return {
      fdata: [],
      contract: [],
      salary_settings: [],
      component_values: [],
      child_component_values: [],
      probation_salary: [],
      optimize_fields: { house_rent: '0', conveyance_allowance: '0', medical_allowance: '0' },
      leave_policy: '',
      roster_leave_policy: '',
      cost_center_info: [],
      addons: [],
    }
  },

  methods: {
    formatMe(d) {
      //alert(d);
      if (d && d != '0000-00-00 00:00:00' && d != '0000-00-00' && d != 'undefined') {
        return moment(d).format('YYYY-MM-DD');
      } else {
        d = '';
      }
    },

    moneyFormat(amount) {
      if (amount && parseFloat(amount) > 0) {
        return amount.toLocaleString();
      }
    },

    contractApproval(cont_id, approval_action, e) {
      e.preventDefault();
      var approval_text = (approval_action > 0) ? 'Approve' : 'Disapprove';
      if (confirm("Do you really want to " + approval_text + " this contract?")) {
        let formData = new FormData();
        formData.append('contract_id', cont_id);
        formData.append('approval_action', approval_action);
        let currentObj = this;
        const config = {};

        axios.post(this.$api_url + '/contract/approval', formData, config)
          .then(function (response) {
            if (response.data.success) {
              this.$bvToast.toast(response.data.message, { title: 'Success', variant: 'success', solid: true });
              this.$emit('event', 'approval');
            } else if (response.data.error) {
              this.$bvToast.toast(response.data.message, { title: 'Error!', variant: 'danger', solid: true });
            }
          }.bind(this))
          .catch(function (error) {
            this.$bvToast.toast(error.response.data.errors.toString(), { title: 'Error!', variant: 'danger', solid: true });
          });


      }
    },

    loadCostCenterInfo() {
      if (this.contract_id) {
        axios.get(this.$api_url + '/get-contract-cost-center', {
          params: {
            contract_id: this.contract_id
          }
        }).then(function (response) {
          //Sohel: New mappings update
          if (response.data.length > 0) {
            this.cost_center_info = response.data;
          } else {
            this.cost_center_info = [];
          }
          //Sohel: New mappings update
        }.bind(this));
      }
    },

    loadContractInfo() {
      if (this.contract_id) {
        axios.get(this.$api_url + '/getcontractinfo/' + this.contract_id, {
          params: {
          }
        }).then(function (response) {
          if (response.data.data) {
            this.contract = response.data.data;
            this.fdata = response.data.data;
            this.loadSalarySettings();
            this.setContractDates();
            /*Roster Leave Policy Update CST Start*/
            if (this.addons.includes('Roster'))
              this.loadRosterLeavePolicy(this.contract.leave_policy);
            else
              this.loadLeavePolicy(this.contract.leave_policy);
            /*Roster Leave Policy Update CST End*/
          }
        }.bind(this));
        this.loadCostCenterInfo();
      }
    },
    setContractDates: function () {
      if (this.contract.probation_start == '0000-00-00')
        this.fdata.probation_start = '';
      if (this.contract.probation_end == '0000-00-00')
        this.fdata.probation_end = '';
      if (this.contract.contract_start == '0000-00-00')
        this.fdata.contract_start = '';
      if (this.contract.contract_end == '0000-00-00')
        this.fdata.contract_end = '';
      if (this.contract.pf_start == '0000-00-00')
        this.fdata.pf_start = '';

    },

    setChildComponentFields(parent_key, child_data) {
      //console.log("parent_key");
      if (parent_key && child_data) {
        //console.log(parent_key);
        this.child_component_values[parent_key] = child_data;
        for (var c_data in child_data) {
          this.component_values[child_data[c_data].field_key] = child_data[c_data].field_value;
        }
      }
    },

    setComponentfields: function () {
      //this.loopidxtest++;
      //console.log('setComponentValues call '+this.loopidxtest);

      if (this.salary_settings.fixed.length > 0) {
        var optimize_fields_array = ['house_rent', 'conveyance_allowance', 'medical_allowance'];

        for (var c_data in this.salary_settings.fixed) {
          if (parseInt(this.salary_settings.fixed[c_data].date_range) != 1)
            this.component_values[this.salary_settings.fixed[c_data].field_name] = this.salary_settings.fixed[c_data].field_value;
          else
            this.component_values[this.salary_settings.fixed[c_data].field_name] = this.salary_settings.fixed[c_data].is_checked;

          if (optimize_fields_array.includes(this.salary_settings.fixed[c_data].field_name))
            this.optimize_fields[this.salary_settings.fixed[c_data].field_name] = '1';

          if (parseInt(this.salary_settings.fixed[c_data].section_only) > 0) {
            if (this.salary_settings.fixed[c_data].child_components)
              this.setChildComponentFields(this.salary_settings.fixed[c_data].field_name, this.salary_settings.fixed[c_data].child_components);
          }
        }
      }

      if (this.salary_settings.fixed_deduction.length > 0) {
        for (var m_data in this.salary_settings.fixed_deduction) {

          this.component_values[this.salary_settings.fixed_deduction[m_data].field_name] = this.salary_settings.fixed_deduction[m_data].field_value;
          if (parseInt(this.salary_settings.fixed_deduction[m_data].section_only) > 0) {
            if (this.salary_settings.fixed_deduction[m_data].child_components)
              this.setChildComponentFields(this.salary_settings.fixed_deduction[m_data].field_name, this.salary_settings.fixed_deduction[m_data].child_components);
          }
        }
      }
      //console.log('Comes here');
      if (this.salary_settings.reserved_data) {
        //console.log('Enter Comes here');
        for (var r_data in this.salary_settings.reserved_data) {
          if (!this.salary_settings.reserved_data[r_data].start) {
            if (this.salary_settings.reserved_data[r_data].field_key)
              this.component_values[this.salary_settings.reserved_data[r_data].field_key] = this.salary_settings.reserved_data[r_data].field_value;
            //console.log('Field Key: '+this.salary_settings.reserved_data[r_data].field_key+', Field Value: '+this.salary_settings.reserved_data[r_data].field_value);
          }
        }
        this.fdata.gross = this.salary_settings.reserved_data.gross_salary.field_value;
        this.fdata.rental_amount = this.salary_settings.reserved_data.rental_amount.field_value;

        //  this.fdata.conveyance_personal_private_cars_upto_2500_cc = (this.salary_settings.reserved_data.conveyance_personal_private_cars_upto_2500_cc && this.salary_settings.reserved_data.conveyance_personal_private_cars_upto_2500_cc.field_value) ? this.salary_settings.reserved_data.conveyance_personal_private_cars_upto_2500_cc.field_value : 0;

        // New slabs for conveyance personal/private related updates: Sohel
        this.fdata.conveyance_personal_private_cars_upto_1500_cc = (this.salary_settings.reserved_data.conveyance_personal_private_cars_upto_1500_cc && this.salary_settings.reserved_data.conveyance_personal_private_cars_upto_1500_cc.field_value) ? this.salary_settings.reserved_data.conveyance_personal_private_cars_upto_1500_cc.field_value : 0;

        this.fdata.conveyance_personal_private_cars_1501_to_2000_cc = (this.salary_settings.reserved_data.conveyance_personal_private_cars_1501_to_2000_cc && this.salary_settings.reserved_data.conveyance_personal_private_cars_1501_to_2000_cc.field_value) ? this.salary_settings.reserved_data.conveyance_personal_private_cars_1501_to_2000_cc.field_value : 0;

        this.fdata.conveyance_personal_private_cars_2001_to_2500_cc = (this.salary_settings.reserved_data.conveyance_personal_private_cars_2001_to_2500_cc && this.salary_settings.reserved_data.conveyance_personal_private_cars_2001_to_2500_cc.field_value) ? this.salary_settings.reserved_data.conveyance_personal_private_cars_2001_to_2500_cc.field_value : 0;
        // New slabs for conveyance personal/private related updates: Sohel

        this.fdata.conveyance_personal_private_cars_above_2500_cc = (this.salary_settings.reserved_data.conveyance_personal_private_cars_above_2500_cc && this.salary_settings.reserved_data.conveyance_personal_private_cars_above_2500_cc.field_value) ? this.salary_settings.reserved_data.conveyance_personal_private_cars_above_2500_cc.field_value : 0;
        this.fdata.rent_paid_by_employee = this.salary_settings.reserved_data.rent_paid_by_employee.field_value;//non-cash update

        // New slabs for conveyance personal/private related updates: Sohel
        if (this.fdata.conveyance_personal_private_cars_upto_1500_cc != 0 || this.fdata.conveyance_personal_private_cars_1501_to_2000_cc != 0 || this.fdata.conveyance_personal_private_cars_2001_to_2500_cc != 0 || this.fdata.conveyance_personal_private_cars_above_2500_cc != 0)
          this.component_values['conveyance_personal_private'] = 1;

        // New slabs for conveyance personal/private related updates: Sohel

        this.fdata.tax_policy = (this.salary_settings.reserved_data.tax_policy && this.salary_settings.reserved_data.tax_policy.field_value != "") ? this.salary_settings.reserved_data.tax_policy.field_value : 0;
      }


      if (this.salary_settings.probation_data) {
        //console.log('Enter Comes here');
        for (var p_data in this.salary_settings.probation_data) {
          if (this.salary_settings.probation_data[p_data].field_key)
            this.probation_salary[this.salary_settings.probation_data[p_data].field_key] = this.salary_settings.probation_data[p_data].field_value;
          //console.log('Field Key: '+this.salary_settings.probation_data[p_data].field_key+', Field Value: '+this.salary_settings.probation_data[p_data].field_value);
        }
      }
    },

    loadSalarySettings: function () {

      axios.get(this.$api_url + '/employeesalarysettings/' + this.contract.employee_id + '/' + this.contract.id, {
        params: {
          all_settings: true /*[UPD: 072024]*/
        }
      }).then(function (response) {
        this.salary_settings = response.data.data;
        this.setComponentfields();


      }.bind(this));
    },
    loadLeavePolicy: function (leave_id) {

      let currentObj = this;

      if (leave_id) {
        axios.get(this.$api_url + '/leave/policy/details/' + leave_id, {
          params: {
          }
        }).then(function (response) {
          if (response.data.title) {
            this.leave_policy = response.data.title;
          }


        }.bind(this));
      }

    },
    loadRosterLeavePolicy: function (leave_id) {

      let currentObj = this;

      if (leave_id) {
        axios.get(this.$api_url + '/leave-attendance/leave/policy/details/' + leave_id, {
          params: {
          }
        }).then(function (response) {
          if (response.data.title) {
            this.roster_leave_policy = response.data.title;
          }


        }.bind(this));
      }

    },
    /*Roster Leave Policy Update CST Start*/
    getCompanyData: function () {
      if (!this.checkNet()) return false;
      axios.get(this.$api_url + '/company/details', {
        params: {
          //id: x
        }
      }).then(function (response) {

        if (response.data.length != 0) {
          this.addons = response.data.module_disabled;
        }
        this.loadContractInfo();
      }.bind(this));
    },
    /*Roster Leave Policy Update CST End*/
  },
  created: function () {
    /*Roster Leave Policy Update CST Start*/
    this.getCompanyData();
    //this.loadContractInfo();
    /*Roster Leave Policy Update CST End*/
  }
}
</script>
